import { useEffect, useState } from "react";
import { Clock } from "lucide-react";
import { HOURS } from "@/lib/site";

const fmt = new Intl.DateTimeFormat("en-US", {
  timeZone: HOURS.timeZone,
  hour: "numeric",
  minute: "2-digit",
  hour12: true,
});

const hourIn = (date) =>
  Number(
    new Intl.DateTimeFormat("en-US", {
      timeZone: HOURS.timeZone,
      hour: "numeric",
      hour12: false,
    }).format(date)
  ) % 24;

const getStatus = () => {
  const now = new Date();
  const h = hourIn(now);
  const open = h >= HOURS.open && h < HOURS.close;
  return { open, time: fmt.format(now) };
};

export default function OpenStatus({ compact = false }) {
  const [status, setStatus] = useState(getStatus);

  useEffect(() => {
    const id = setInterval(() => setStatus(getStatus()), 30000);
    return () => clearInterval(id);
  }, []);

  return (
    <span
      data-testid="open-status-badge"
      className={`inline-flex items-center gap-2 rounded-full border px-3 py-1.5 text-xs font-medium ${
        status.open
          ? "border-wa/40 bg-wa/10 text-cream"
          : "border-champagne/30 bg-champagne/10 text-champagne"
      } ${compact ? "" : "sm:text-sm"}`}
    >
      <span className="relative flex h-2 w-2">
        {status.open && (
          <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-wa opacity-75" />
        )}
        <span
          className={`relative inline-flex h-2 w-2 rounded-full ${
            status.open ? "bg-wa" : "bg-champagne"
          }`}
        />
      </span>
      <span data-testid="open-status-text" className="font-semibold">
        {status.open ? "Open Now" : `Opens ${HOURS.openLabel}`}
      </span>
      <span className="text-cream/60" aria-hidden="true">
        ·
      </span>
      <Clock className="h-3.5 w-3.5 text-[#EF7CC2]" />
      <span data-testid="open-status-time" className="tabular-nums text-cream/85">
        {status.time} Dubai
      </span>
    </span>
  );
}
